<template>
    <div>
        <Table border :loading="loading" :columns="columns" :data="data"> </Table>
        <div style="margin:20px 0;">
            <Page style="float: right" :total="total" @on-change="pageChange"/>
        </div>
    </div>
</template>

<script>
import DateUtil from "@/util/DateUtil";
export default {
    data(){
        return{
            date: new DateUtil(),
            loading:false,
            pageInfo: {
                itemCount: 0,
                pageNo: 1,
                pageSize: 10,
            },
            total: 0,
            data:[],
        }
    },
    computed:{
        columns(){
            return [
                {
                    title: this.$t('Operator'),/* 操作人 */
                    key: "userName",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                },{
                    title: this.$t('Action_Time'),/* 操作时间 */
                    key: "operationDate",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                }
            ]
        }
    },
    methods:{
        pageChange(val){
            this.pageInfo.pageNo = val
            this.$emit('pageChangeOperation',this.pageInfo)
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/MyAchievementsComponents/OperationHistory.vue